"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _curry2;

var _curry = _interopRequireDefault(require("./_curry1")),
    _isPlaceholder2 = _interopRequireDefault(require("./_isPlaceholder"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _curry2(c) {
  return function d(e, a) {
    switch (arguments.length) {
      case 0:
        return d;

      case 1:
        return (0, _isPlaceholder2["default"])(e) ? d : (0, _curry["default"])(function (a) {
          return c(e, a);
        });

      default:
        return (0, _isPlaceholder2["default"])(e) && (0, _isPlaceholder2["default"])(a) ? d : (0, _isPlaceholder2["default"])(e) ? (0, _curry["default"])(function (b) {
          return c(b, a);
        }) : (0, _isPlaceholder2["default"])(a) ? (0, _curry["default"])(function (a) {
          return c(e, a);
        }) : c(e, a);
    }
  };
}